import Vue from "vue";
import VueTippy, { TippyComponent } from "vue-tippy";

import "@/sass/tippy.scss";

Vue.use(VueTippy, {
	// Use our own custom tippy theme
	theme: "material",
	// Keep tooltip attached to target element, even if it moves
	sticky: true,
	// Append new tippy DOM elements in .v-application to inherit vuetify styling
	appendTo: () => document.querySelector(".v-application"),
	// By default, put tippy z-index *below* vuetify overlays/dialogs
	zIndex: 200,
});
Vue.component("tippy", TippyComponent);
